import angular from 'angular'
import template from './template.html'

angular.module('nominas.nomina')
  .component('nominasNominaInformacionFechapago', {
    template: template,
    controller: NominasNominaInformacionFechapagoComponent,
    bindings: {
      data: '<',
      editable: '<',
    },
  })

function NominasNominaInformacionFechapagoComponent($moment) {
  let $ctrl = this

  $ctrl.$onInit = $onInit
  $ctrl.actualizar = actualizar

  function $onInit() {
    $ctrl.editando = false
    setFechaPago()
  }

  function actualizar(fecha_pago) {
    $ctrl.data.fecha_pago = fecha_pago
    setFechaPago()
    $ctrl.editando = false
  }

  function setFechaPago() {
    $ctrl.fecha_pago = 'La nómina '
      + ($ctrl.data.fecha_pago > new Date() ? 'será pagada ' : 'fue pagada ')
      + $moment($ctrl.data.fecha_pago).format('[el] D [de] MMMM [de] YYYY')
  }
}



// WEBPACK FOOTER //
// ./src/nominas/nomina/components/informacion/fechapago/component.js